<template>
  <v-form
    ref="codeDiscount"
    class="code-discount-input"
    @submit.prevent
  >
    <v-text-field
      id="code-discount"
      v-model="discountCode.input"
      label="請輸入優惠代碼或推薦碼"
      single-line
      outlined
      maxlength="20"
      :hide-details="'auto'"
      :error="!discountCode.validation"
      :error-messages="discountCode.showText"
      type="text"
      @click.native="discountCode.validation = true"
      @input="discountCode.showText = ''"
      @keypress.enter.prevent="discountCodeConfirmHandler(false)"
    />
    <v-btn
      :loading="discountCode.isSaving"
      class="btn-save"
      :color="discountCode.input ? 'primary' : undefined"
      :disabled="!discountCode.input"
      @click="discountCodeConfirmHandler(false)"
    >
      確認
    </v-btn>
  </v-form>
</template>

<script>
import ticketAndBonus from '@/mixin/ticketAndBonus'
const discountErrorList = [411066, 411067, 400002, 404015, 404016, 404021, 404022, 404030, 404031, 404032, 404033, 404000, 411001, 411002, 411003, 411004, 411005, 411006, 404008, 409008, 404036, 409003]
const discountErrorTextEnum = {
  411066: '當前服務不適用此代碼',
  411067: '當前服務不適用此代碼',
  400002: '此服務無折扣碼活動',
  404015: '無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用',
  404016: '推薦碼已操作會員轉換',
  404021: '請勿輸入自己的推薦代碼',
  404022: '當前帳號不符合使用條件',
  404030: '當前服務不適用此代碼',
  404031: '無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用',
  404032: '當前帳號已超過使用次數',
  404033: '當前折扣碼已超過總使用次數',
  404000: '當無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用前折扣碼已超過總使用次數',
  411001: '無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用',
  411002: '無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用',
  411003: '優惠尚未開放領取，請等待至指定時間再領取',
  411004: '優惠已經停止領取囉，下回請早',
  411005: '您已經領取過這個優惠，不能再領取囉',
  411006: '慢一步了，優惠已經被領取完畢囉',
  404008: '無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用',
  409008: '當前折扣碼已超過總此代碼已經被領取過囉！使用次數',
  404036: '無效的代碼，可能為輸入錯誤（請注意英文大小寫）或是代碼無法再使用',
  409003: '此代碼已經被領取過囉！'
}
export default {
  mixins: [ticketAndBonus],
  inject: {
    isQuotationMode: {
      from: 'isQuotationMode',
      default: false
    },
    orderId: {
      from: 'orderId',
      default: null
    },
    getQuotationId: {
      from: 'getQuotationId',
      default: null
    }
  },
  props: {
    isPhoneValidate: {
      default: false,
      type: Boolean
    },
    canUseEnterpriseCoin: {
      default: false,
      type: Boolean
    },
    orderAmount: {
      default: 0,
      type: Number
    },
    service: {
      default: () => {},
      type: Object
    },
    serviceId: {
      default: null,
      type: Number | String
    },
    serviceTypeId: {
      default: null,
      type: Number | String
    },
    orderId: {
      default: null,
      type: Number | String
    },
    ticketAmount: {
      default: 0,
      type: Number
    },
    canUseBonusAmount: {
      default: 0,
      type: Number
    },
    bonusAmount: {
      default: 0,
      type: Number
    },
    discountData: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      discountCode: {
        isSaving: false,
        input: '',
        showText: '',
        validation: true,
        acceptResult: null
      }
    }
  },
  computed: {
    quotationId () {
      if (typeof this.getQuotationId !== 'function') return null
      return this.getQuotationId()
    },
    enterpriseCoinAvailable () {
      const enterpriseCoinAvailableServiceTypeId = this.$nuxt.context.env.ENTERPRISE_POINT_AVAILABLE_SERVICE_TYPE_ID
      return enterpriseCoinAvailableServiceTypeId.includes(this.serviceTypeId)
    },
    codeDiscountAmount () {
      return this.discountData?.code?.discount || 0
    },
    orderAmountWithCodeAndTicketAmount () {
      return this.orderAmount - this.discountData.code.discount - this.discountData.ticket.discount
    }
  },
  watch: {
    'discountData.tempInput': {
      handler (newVal) {
        this.discountCode.input = _.cloneDeep(newVal)
      },
      immediate: true
    }
  },
  beforeDestroy () {
    this.$emit('updateDiscountUsage', {
      type: 'tempInput',
      data: _.cloneDeep(this.discountCode.input)
    })
  },
  methods: {
    validateDiscountInput () {
      if (this.discountCode.input.length === 7 && !this.isPhoneValidate) {
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '請先進行手機驗證',
          type: 'error'
        })
        return false
      }
      if (this.discountCode.input === this.discountData.code.input) {
        this.setDiscountCodeInputState(false)
        this.discountCode.showText = this.discountCode.input.length === 7 ? '推薦優惠已套用' : '優惠已套用'
        return false
      }
      if (this.discountData.bonus?.enterpriseCodes?.some(v => v === this.discountCode.input)) {
        this.setDiscountCodeInputState(false)
        this.discountCode.showText = '優惠已套用'
        return false
      }
      return true
    },
    async getIntegrateDiscountCode (isAutoCheck = false, discountInput) {
      if (!this.validateDiscountInput() && !isAutoCheck) return
      try {
        if (this.isQuotationMode) return await this.getIntegrateDiscountCodeForQuotation(discountInput)
        const { data } = await this.$axios.post('/api/CodeDiscount/GetIntegrateDiscountCode', {
          Code: discountInput || this.discountCode.input,
          ServiceId: parseInt(this.serviceId),
          NowOrderAmount: this.orderAmount
        })
        return Promise.resolve(data.Data)
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
    async getIntegrateDiscountCodeForQuotation (discountInput) {
      try {
        const postData = {
          Code: discountInput || this.discountCode.input,
          NowOrderAmount: this.orderAmount
        }
        const { data } = await this.$axios.post(`/api/CodeDiscount/${this.orderId}/Quotation/${this.quotationId}/GetIntegrateDiscountCode`, postData)
        return Promise.resolve(data.Data)
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
    async discountCodeConfirmHandler (isAutoCheck = false, discountInput) {
      if (!this.validateDiscountInput() && !isAutoCheck) return
      try {
        if (!this.$auth.loggedIn && this.discountCode.input.length === 10) {
          await this.receiveEnterpriseBonusHandler()
          return
        }
        this.discountCode.isSaving = true
        const {
          GiftDiscount,
          EnterpriseCoin,
          NormalDiscount,
          RecommendDiscount
        } = await this.getIntegrateDiscountCode(isAutoCheck, discountInput)
        if (GiftDiscount || EnterpriseCoin) {
          if (GiftDiscount) {
            await this.giftDiscountHandler(GiftDiscount)
            if (GiftDiscount.Bonus) {
              this.$infobipTrackEvent('receiveGift', {
                type: 'Bonus',
                bonusAmount: `${GiftDiscount.Bonus.BonusAmount}`
              })
            }
            if (GiftDiscount.Tickets && GiftDiscount.Tickets.length) {
              const ticketList = GiftDiscount.Tickets.map(ticket => ({
                dueDate: (ticket.ValidDueTo && ticket.ValidDueTo.slice(0, -9)) || '',
                description: ticket.Description,
                name: ticket.Name,
                id: `${ticket.Id}`
              }))
              const ticketListString = ticketList.length >= 1 ? `_${ticketList.map(ticket => ticket.id).join('_')}_` : ''
              this.$infobipTrackEvent('receiveGift', {
                type: 'Ticket',
                ticketListString,
                ticketList
              })
            }
          }
          if (EnterpriseCoin) {
            this.showGiftPopup(`恭喜您獲得了【智生活企業點數${EnterpriseCoin.EnterpriseCoinAmount}點】<br />點數已存入您的帳戶！`)
            this.$infobipTrackEvent('receiveGift', {
              type: 'EnterpriseCoin',
              bonusAmount: `${EnterpriseCoin.EnterpriseCoinAmount}`
            })
          }
          if (GiftDiscount?.Bonus || EnterpriseCoin) {
            this.updateAvaliableBonusHandler(true, {
              ServiceId: this.serviceId,
              OrderAmount: this.orderAmountWithCodeAndTicketAmount
            })
          } // 重新取得可使用紅利點數
          this.setDiscountCodeInputState(true)
        } else if (NormalDiscount || RecommendDiscount) {
          const discountDetail = NormalDiscount || RecommendDiscount
          const OrderActivityType = RecommendDiscount ? 1 : 2
          if (this.discountData.code.isUse && OrderActivityType !== this.discountData.code.detail.OrderActivityType) {
            const replaceDiscountCheck = await this.confirmReplaceDiscount()
            if (!replaceDiscountCheck) {
              this.discountCode.isSaving = false
              return
            }
          }
          this.codeAndReferrerDiscountHandler({
            OrderActivityType,
            ...discountDetail
          }, isAutoCheck)
        }
        this.discountCode.isSaving = false
      } catch (error) {
        console.log('error', error)
        this.setDiscountCodeInputState(false)
        if (!this.discountCode.input && discountInput) {
          this.discountCode.input = discountInput
          this.$emit('updateDiscountUsage', {
            type: 'code',
            data: {
              detail: null,
              input: '',
              discount: 0,
              isUse: false
            },
            isAutoCheck
          })
        }
        const errorCode = error?.response?.data?.ErrorMessage?.Code
        if (errorCode === 400031) {
          this.$alert({
            title: '系統提示',
            message: '若需要領取優惠券或紅利點數請先進行登入',
            btn: [
              {
                btnText: '取消',
                btnClick: () => {
                  this.$alert.close()
                }
              },
              {
                btnText: '立即登入',
                btnColor: 'primary',
                btnClick: () => {
                  this.$alert.close()
                  this.$emit('memberLogin')
                }
              }
            ],
            clickOutside: () => {
              this.$alert.close()
            }
          })
        } else if (discountErrorList.includes(errorCode)) {
          this.discountCode.showText = discountErrorTextEnum[error.response.data.ErrorMessage.Code]
        } else {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '使用失敗，請稍後再試',
            type: 'error'
          })
        }
        if (isAutoCheck) {
          this.$alert({
            title: '系統提示',
            message: '很抱歉，您當前輸入的代碼無法使用',
            btnText: '確定',
            persistent: true,
            btnDonFun: () => {
              const headerHeight = document.querySelector('#header').offsetHeight
              this.$vuetify.goTo('#code-discount', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
              this.$alert.close()
            }
          })
        }
        this.discountCode.isSaving = false
      }
    },
    async receiveEnterpriseBonusHandler () {
      try {
        this.discountCode.isSaving = true
        const { data } = await this.$axios.post('/api/CodeDiscount/Guest/GetEnterpriseCoinDiscountCode', {
          Code: this.discountCode.input
        })

        if (!this.canUseEnterpriseCoin) {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '本服務不適用企業點數折抵！',
            type: 'error'
          })
          this.setDiscountCodeInputState(true)
          this.discountCode.isSaving = false
          return
        }

        const tempBonus = _.cloneDeep(this.discountData.bonus)
        let receivedEnterpriseCoinAmount = tempBonus?.point?.CanUseEnterpriseAmount || 0
        const totalEnterpriseCoinAmount = receivedEnterpriseCoinAmount += data.Data.VirtualAmount
        tempBonus.enterpriseCodes.push(_.cloneDeep(this.discountCode.input))
        this.$emit('updateDiscountUsage', {
          type: 'bonus',
          data: {
            ...tempBonus,
            state: 'used',
            point: {
              CanUseBonusAmount: 0,
              CanUseEnterpriseAmount: this.orderAmountWithCodeAndTicketAmount > totalEnterpriseCoinAmount ? totalEnterpriseCoinAmount : this.orderAmountWithCodeAndTicketAmount,
              OriginEnterpriseCoinResult: totalEnterpriseCoinAmount
            }
          }
        })
        this.setDiscountCodeInputState(true)
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '使用成功！',
          type: 'success'
        })
        this.discountCode.isSaving = false
      } catch (error) {
        console.log('err', error)
        const errorCode = error?.response?.data?.ErrorMessage?.Code
        if (discountErrorList.includes(errorCode)) {
          this.discountCode.showText = discountErrorTextEnum[error.response.data.ErrorMessage.Code]
        } else {
          this.$store.dispatch('toast', {
            isOpen: true,
            text: '使用失敗，請稍後再試',
            type: 'error'
          })
        }
        this.discountCode.isSaving = false
      }
    },
    showGiftPopup (messageHTML) {
      this.$alert({
        title: '獲得專屬好禮！',
        messageHTML,
        btn: [
          {
            btnText: '我知道了',
            btnColor: 'primary',
            btnIsLoading: false,
            btnClick: () => {
              this.$alert.close()
            }
          }
        ]
      })
    },
    async giftDiscountHandler (gift) {
      try {
        let messageHTML = ''
        if (gift?.Tickets?.length) {
          messageHTML = `恭喜您獲得了【生活服務優惠券${gift.Tickets.length}張】<br />優惠券已存入您的帳戶！`
        } else {
          messageHTML = `恭喜您獲得了【紅利點數${gift.Bonus.BonusAmount}點】<br />點數已存入您的帳戶！`
        }
        this.setDiscountCodeInputState(true)
        if (gift.Tickets) {
          if (!this.discountData.ticket.TicketInstanceId) {
            const orderAmount = this.orderAmount - this.codeDiscountAmount
            const ticketData = await this.getTicketAvailableForService(
              {
                ServiceId: this.serviceId,
                OrderAmount: orderAmount
              }
            )
            if (ticketData.length) {
              const avaliableReceivedTicketIndex = ticketData.findIndex(ticket => gift.Tickets.some(v => (parseInt(v.Id) === parseInt(ticket.Id)) && (ticket.OrderDiscount <= orderAmount)))
              const avaliableReceivedTicket = ticketData[avaliableReceivedTicketIndex]
              if (avaliableReceivedTicket) {
                this.$emit('updateDiscountUsage', {
                  type: 'ticket',
                  data: {
                    TicketInstanceId: avaliableReceivedTicket.TicketInstanceId,
                    index: avaliableReceivedTicketIndex,
                    discount: avaliableReceivedTicket.OrderDiscount,
                    detail: avaliableReceivedTicket,
                    list: ticketData
                  }
                })
              }
            }
          }
        }
        this.showGiftPopup(messageHTML)
      } catch (err) {
        console.log(err)
      }
    },
    async codeAndReferrerDiscountHandler (discountDetail, isAutoCheck = false) {
      try {
        const headerHeight = document.querySelector('#header').offsetHeight
        const showCodeDiscountAreaCheckFromEnterError = () => {
          this.$alert({
            title: '系統提示',
            message: '很抱歉，您當前輸入的代碼無法使用',
            btnText: '確定',
            persistent: true,
            btnDonFun: () => {
              this.$vuetify.goTo('#code-discount', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
              this.$alert.close()
            }
          })
        }
        if (discountDetail) {
          if (discountDetail.DiscountAmount > 0) {
            const tempOrderAmountWithDiscount = this.orderAmount - discountDetail.DiscountAmount

            if (!isAutoCheck) {
              if (this.ticketAmount > 0) {
                await this.checkTicketUsageHandler(true, { ServiceId: this.serviceId, OrderAmount: tempOrderAmountWithDiscount })
              }

              if (this.canUseBonusAmount > 0 && this.discountCode.acceptResult !== false) {
                await this.updateAvaliableBonusHandler(isAutoCheck, {
                  ServiceId: this.serviceId,
                  OrderAmount: tempOrderAmountWithDiscount - this.ticketAmount
                })
              }

              if (this.discountCode.acceptResult === false) return
              this.$store.dispatch('toast', {
                isOpen: true,
                text: '使用成功！已套用優惠',
                type: 'success'
              })
            }

            this.$emit('updateDiscountUsage', {
              type: 'code',
              data: {
                input: isAutoCheck ? this.discountData.code.input : _.cloneDeep(this.discountCode.input),
                detail: discountDetail,
                discount: discountDetail.DiscountAmount,
                isUse: true
              },
              isAutoCheck
            })

            this.setDiscountCodeInputState(true)
          } else {
            this.$vuetify.goTo('#code-discount', { duration: 300, offset: headerHeight, easing: 'easeInOutQuad' })
            this.$emit('updateDiscountUsage', {
              type: 'code',
              data: {
                detail: null,
                input: '',
                discount: 0,
                isUse: false
              },
              isAutoCheck
            })
            if (isAutoCheck) {
              showCodeDiscountAreaCheckFromEnterError()
            } else {
              this.setDiscountCodeInputState(false)
              this.discountCode.showText = '當前訂單金額不滿足折扣條件'
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    setDiscountCodeInputState (state) {
      if (state) {
        this.discountCode.input = ''
        this.discountCode.validation = true
        this.discountCode.showText = ''
      } else {
        this.discountCode.validation = false
      }
    },
    confirmReplaceDiscount () {
      return new Promise((resolve, reject) => {
        this.$alert({
          title: '系統提示',
          message: '折扣碼與推薦碼不可同時使用，確定要套用新的折扣內容嗎？',
          btn: [
            {
              btnText: '取消',
              btnColor: '',
              depressed: true,
              outlined: false,
              btnClick: () => {
                this.$alert.close()
                resolve(false)
              }
            },
            {
              btnText: '確定',
              btnColor: 'primary',
              depressed: true,
              btnIsLoading: false,
              btnClick: async () => {
                this.$alert.close()
                resolve(true)
              }
            }
          ],
          persistent: true
        })
      })
    }
  }
}
</script>

<style lang="scss">
.code-discount-input {
  display: flex;
  align-items: baseline;
  grid-gap: 0 10px;
  gap: 0 10px;
}

</style>
